import type {Context} from '../types';

const targetedNodeTypes: Record<string, boolean> = {
  CommerceCheckoutBillingAddressToggleCheckbox: true,
  CommerceCheckoutBillingAddressWrapper: true,
  CommerceCheckoutCustomerInfoWrapper: true,
  CommerceCheckoutErrorState: true,
  CommerceCheckoutFormContainer: true,
  CommerceCheckoutPlaceOrderButton: true,
  CommerceCheckoutShippingAddressWrapper: true,
  CommerceCheckoutShippingMethodsWrapper: true,
  CommerceOrderConfirmationContainer: true,
};

// Fix up legacy Stripe elements
export default (context: Context) => {
  const {
    node: {jsonNode},
  } = context;
  const {type, data = {}} = jsonNode;

  const needed =
    type &&
    targetedNodeTypes[type] &&
    data &&
    data.attr &&
    data.attr['data-node-type'];

  return {
    needed,
    logData: {
      msg: 'Legacy Stripe element with `data-node-type` attribute',
      meta: {
        nodeId: jsonNode._id,
      },
    },
    apply: () => {
      // eslint-disable-next-line webflow/no-delete
      delete data.attr['data-node-type'];
      if (Object.keys(data.attr).length === 0) {
        // eslint-disable-next-line webflow/no-delete
        delete data.attr;
      }
    },
  };
};
